<template>
    <div style="height: 100%; width: 100%; overflow-y: scroll">
        <transition key="1" name="fade" mode="in-out">
            <graph-loader v-show="!taskInfoReady"/>
        </transition>
        <template v-if="taskInfoReady">
            <h1>{{ taskInfo.name }} <v-badge v-if="taskInfoReady" :type="taskStatusToBadgeType(taskInfo.state)"> {{ taskStatus }}</v-badge> </h1>
            <h2> <i class="plat-icon" :class="methodInfo.platform.icon"> </i> {{ methodInfo.name }} </h2>
            <h3>
                <i class="plat-icon far fa-calendar-alt"></i>
                {{ taskStartTime }}
                <template v-if="taskEndTime">- {{taskEndTime}}</template>
            </h3>
            <task-parameters v-if="taskInfoReady" :fields="methodInfo.methodFields" readonly />
            <div v-if="isTaskSuccessful">
                <h2> Результат </h2>
                <a :href="downloadLink()" download="">
                    <v-button label="Скачать"/>
                </a>
            </div>
            <div v-else>
                <h2> Результат </h2>
                <div v-if="isTaskFailed">
                    <b class="error-text">Информация об ошибке</b>
                    <p class="error-text">  {{taskInfo.result.errorText}} </p>
                </div>
                <v-button :disabled="true" label="Скачать"/> <span class="warn"> Задача не выполнена </span>
            </div>
        </template>
    </div>
</template>

<script>
import GraphLoader from "../GraphLoader";
import TaskParameters from "../TaskParameters";
import vButton from "../vButton";
import { TasksAPI } from 'api-client'
import { MethodsAPI } from 'api-client'
import vBadge from "../vBadge";
import humps from 'humps'
import moment from 'moment'

moment.locale('ru')

export default {
  name: "TaskDetails",

  components: {
    TaskParameters,
    GraphLoader,
    vButton,
    vBadge
  },

  props: {
    task: Object,
  },

  data() {
    return {
      taskInfoReady: false,
      taskInfo: {
        taskId: "",
        name: "",
        methodId: 0,
        addedAt: 0,
        state: "",
        result: {
          errorText: "",
          timeFinished: null,
        },
        args: {
          simpleArgs: {},
          fileArgs: [],
        },
        method: {
          id: 0,
          name: '',
          platform: {
            code: "",
            name: "",
            icon: "",
          },
          category: '',
        },
      },
      methodInfo: {
        id: 0,
        name: '',
        help: '',
        platform: {
          code: "",
          name: "",
          icon: "",
        },
        category: '',
        outputTypes: [],
        methodFields: [],
      },
    }
  },

  async created() {
    this.taskInfo = await TasksAPI.taskInfo(this.task)
    this.methodInfo = await MethodsAPI.methodInfo(this.taskInfo.method.id)
    this.injectTaskInfoValuesIntoMethodInfo()
    this.taskInfoReady = true
  },

  computed: {
    isTaskSuccessful() {
      return this.taskInfo.state === 'SUCCESS'
    },
    isTaskFailed() {
      return this.taskInfo.state === 'ERROR'
    },
    taskStartTime() {
      return this.prettifyDateTime(this.taskInfo.addedAt)
    },
    taskEndTime() {
      if (!this.taskInfo.result.timeFinished) {
        return null
      }
      let time = this.prettifyDateTime(this.taskInfo.result.timeFinished)
      if (time === this.taskStartTime) {
        return null
      }
      return time
    },
    taskStatus() {
      switch (this.taskInfo.state.toLowerCase()) {
        case "success":  return "Успешно"
        case "pending":  return "В очереди"
        case "error":    return "Ошибка"
        case "progress": return "Выполнение"
        default:         return this.taskInfo.state
      }
    },
  },

  methods: {
    // Takes args from taskInfo and injects them as values into methodInfo
    injectTaskInfoValuesIntoMethodInfo() {
      for (let field of this.methodInfo.methodFields) {
        const camelizedKey = humps.camelize(field.key)
        if (!!this.taskInfo.args.simpleArgs[camelizedKey]) {
          field.value = this.taskInfo.args.simpleArgs[camelizedKey];
        } else {
          let fileArg = null;
          if (Array.isArray(this.taskInfo.args.fileArgs)) {
            fileArg = this.taskInfo.args.fileArgs.find((f) => f.name === field.key);
          }
          else {
            fileArg = this.taskInfo.args.fileArgs[camelizedKey];
          }
          if (fileArg) {
            field.type = "file-preview"
            field.value = fileArg
          }
        }
      }
    },

    prettifyDateTime(time) {
      const momentObj =  moment.unix(time)
      return momentObj.calendar(null, {
        sameDay: 'Сегодня h:mm',
        nextDay: 'Завтра h:mm',
        lastWeek: 'D MMMM',
        sameElse: 'D MMMM'
      });
    },

    downloadLink() {
      return TasksAPI.downloadResultRoute(this.taskInfo)
    },

    taskStatusToBadgeType(status) {
      switch (status) {
        case "SUCCESS":
          return "success"
        case "ERROR":
          return "danger"
        case "PENDING":
          return "light"
        case "PROGRESS":
          return "primary"
        default:
          window.console.warn("Got unknown task status: '" + status + "'")
          return "light"
      }
    },
  },
}
</script>

<style scoped lang="sass">
    .plat-icon
        margin-right: 5px

    .warn
        margin-left: 10px

    .error-text
        /*border: 1px  #a94442 solid*/
        color: #a94442


</style>
